import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks';

import { AuthTags } from '~constants/authTags';

import { ClickableIcon, ContainerHeader, TabContainer } from '~components';
import { faCog } from '~components/icon';

import { getAll as getAllClients } from '~main/actions/clients';

import BudgetServices from './BudgetServices';
import SupplierInvoices from './supplier-invoices/SupplierInvoices';
import SupplierInvoiceSettingsModal from './supplier-invoices/SupplierInvoiceSettingsModal';

const SuppliersContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const tabs = [
    {
      id: 'sah-supplier-invoices',
      title: 'Supplier Invoices',
      component: SupplierInvoices,
      authTag: AuthTags.SUPPORTATHOME.SUPPLIERINVOICES.VIEW,
    },
    {
      id: 'budget-services',
      title: 'Budget Services',
      component: BudgetServices,
      authTag: AuthTags.SUPPORTATHOME.SUPPLIERINVOICES.VIEW,
    },
  ];

  useEffect(() => {
    dispatch(getAllClients());
  }, []);

  return (
    <div className="p-2">
      <ContainerHeader dataCy="suppliers-header" className="info">
        <div className="d-flex align-items-center gap-1">
          <span>Suppliers / External Providers</span>
          <ClickableIcon
            icon={faCog}
            id={'settings_button'}
            toolTip="Edit Invoice Settings"
            onClick={() => setIsOpen(true)}
            authTag={AuthTags.SUPPORTATHOME.SUPPLIERINVOICES.SETTINGS}
            dataCy="supplier-invoices-settings-icon"
          />
        </div>
      </ContainerHeader>
      <TabContainer tabs={tabs} />
      <SupplierInvoiceSettingsModal setIsOpen={setIsOpen} isOpen={isOpen} />
    </div>
  );
};

export default SuppliersContainer;
